"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6647],{

/***/ 26647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Mapbox; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react-leaflet/esm/hooks.js
var hooks = __webpack_require__(9941);
// EXTERNAL MODULE: ./node_modules/react-leaflet/esm/TileLayer.js
var TileLayer = __webpack_require__(74284);
// EXTERNAL MODULE: ./node_modules/react-leaflet/esm/ZoomControl.js
var ZoomControl = __webpack_require__(95581);
// EXTERNAL MODULE: ./node_modules/react-leaflet-markercluster/dist/index.js
var dist = __webpack_require__(86342);
// EXTERNAL MODULE: ./utils/common.ts
var common = __webpack_require__(6628);
// EXTERNAL MODULE: ./hooks/useStores.ts
var useStores = __webpack_require__(19263);
// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__(57557);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ./node_modules/mobx-react/dist/mobxreact.esm.js
var mobxreact_esm = __webpack_require__(29323);
// EXTERNAL MODULE: ./node_modules/react-leaflet/esm/Marker.js
var Marker = __webpack_require__(27409);
// EXTERNAL MODULE: ./node_modules/react-leaflet/esm/Tooltip.js
var Tooltip = __webpack_require__(97651);
// EXTERNAL MODULE: ./components/pages/DetailPage/utils.tsx
var utils = __webpack_require__(26704);
// EXTERNAL MODULE: ./components/pages/ListingPage/components/RoomCard/index.tsx + 2 modules
var RoomCard = __webpack_require__(24439);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js
var chakra_ui_system_esm = __webpack_require__(46052);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(84632);
// EXTERNAL MODULE: ./node_modules/leaflet/dist/leaflet-src.js
var leaflet_src = __webpack_require__(45243);
var leaflet_src_default = /*#__PURE__*/__webpack_require__.n(leaflet_src);
// EXTERNAL MODULE: ./node_modules/react-leaflet/esm/Popup.js
var Popup = __webpack_require__(8543);
;// CONCATENATED MODULE: ./components/pages/ListingPage/components/Marker/marker.styles.ts




var MarkerText = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Text */.xv, {
    baseStyle: function() {
        return {
            fontSize: "sm",
            lineHeight: "20px",
            fontWeight: 700,
            color: "#fff"
        };
    }
});
var MarkerWrapper = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Box */.xu, {
    baseStyle: function() {
        return {
            width: 320
        };
    }
});
var marker_styles_Popup = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Popup/* Popup */.G, {
    target: "e1jdq3740"
})(".leaflet-popup-content-wrapper{background:transparent;box-shadow:none;}.leaflet-popup-content{margin-left:5px;}.leaflet-popup-tip-container{display:none;}");
var createClusterCustomBlackMarker = function createClusterCustomBlackMarker() {
    return leaflet_src_default().divIcon({
        html: '<span><svg width="150" height="150" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <rect rx="4" ry="4" width="69" height="36" style="fill:#242E2E;stroke:white;stroke-width:1">\n    </rect>\n    </svg>\n    </span>',
        className: "leaflet-marker",
        iconSize: leaflet_src_default().point(71, 15, false)
    });
};
var createClusterCustomTealMarker = function createClusterCustomTealMarker() {
    return leaflet_src_default().divIcon({
        html: '<span><svg width="150" height="150" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <rect rx="4" ry="4" width=  "69" height="36" style="fill:#319795;stroke:white;stroke-width:1">\n    </rect>\n    </svg>\n    </span>',
        className: "leaflet-selected-marker",
        iconSize: leaflet_src_default().point(71, 15, false)
    });
};

;// CONCATENATED MODULE: ./components/pages/ListingPage/components/Marker/index.tsx










var Marker_Marker = function(props) {
    var closePopupOnClick = function closePopupOnClick(event) {
        event.stopPropagation();
        map.closePopup();
    };
    var setSelectedMarker = function setSelectedMarker() {
        if (id) {
            listingStore.setSelectedHouseId(id);
            changePosition(fakeLat !== null && fakeLat !== void 0 ? fakeLat : lat, fakeLng !== null && fakeLng !== void 0 ? fakeLng : lng);
        }
    };
    var openPopup = function openPopup() {
        var markerElement = document.querySelector(".leaflet-selected-marker");
        if (markerElement) {
            markerElement.click();
        }
    };
    var id = props.id, lat = props.lat, lng = props.lng, fakeLat = props.fakeLat, fakeLng = props.fakeLng, lowestUnitPrice = props.lowestUnitPrice, _media = props.media, media = _media === void 0 ? [] : _media, changePosition = props.changePosition;
    var map = (0,hooks/* useMap */.Sx)();
    var listingStore = (0,useStores/* useStores */.m)().listingStore;
    var selectedHouseId = listingStore.selectedHouseId;
    var cardImages = (0,utils/* getMedia */.om)(media);
    (0,react.useEffect)(function() {
        if (selectedHouseId === id) {
            setTimeout(function() {
                openPopup();
            }, 0);
        }
    }, [
        selectedHouseId
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Marker/* Marker */.J, {
        position: [
            fakeLat !== null && fakeLat !== void 0 ? fakeLat : lat,
            fakeLng !== null && fakeLng !== void 0 ? fakeLng : lng
        ],
        icon: selectedHouseId === id ? createClusterCustomTealMarker() : createClusterCustomBlackMarker(),
        eventHandlers: {
            click: setSelectedMarker
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* Tooltip */.u, {
                direction: "center",
                offset: [
                    -8,
                    -2
                ],
                opacity: 1,
                permanent: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MarkerText, {
                    children: [
                        "$",
                        lowestUnitPrice
                    ]
                })
            }),
            selectedHouseId === id && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marker_styles_Popup, {
                closeButton: false,
                closeOnClick: false,
                closeOnEscapeKey: true,
                className: "house-card-popup",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarkerWrapper, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RoomCard/* default */.Z, (0,_object_spread/* default */.Z)({
                        popup: true,
                        closePopupOnClick: closePopupOnClick,
                        images: cardImages
                    }, omit_default()(props, "images")))
                })
            })
        ]
    });
};
/* harmony default export */ var components_Marker = ((0,mobxreact_esm/* observer */.Pi)(Marker_Marker));

// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js + 1 modules
var chakra_ui_button_esm = __webpack_require__(85054);
// EXTERNAL MODULE: ./enums/theme/index.ts
var theme = __webpack_require__(60431);
;// CONCATENATED MODULE: ./components/pages/ListingPage/components/Mapbox/mapbox.styles.ts



var BackButton = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_button_esm/* Button */.zx, {
    baseStyle: function() {
        return {
            position: "absolute",
            top: "6",
            left: "6",
            border: "solid 1px",
            borderColor: "background.grey.200",
            background: "#fff",
            display: {
                base: "flex",
                lg: "none"
            },
            justifyContent: "center",
            alignItems: "center",
            zIndex: theme/* EZIndexLayer.CONTENT_VIEW */.qd.CONTENT_VIEW
        };
    }
});
var BackButtonText = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Text */.xv, {
    baseStyle: function() {
        return {
            color: "text.grey.700",
            fontSize: "lg",
            fontFamily: "Inter",
            fontWeight: 600,
            marginLeft: "10px"
        };
    }
});
var createClusterCustomIcon = function createClusterCustomIcon(cluster) {
    return leaflet_src_default().divIcon({
        html: '<span><svg width="46" height="59" viewBox="0 0 46 59" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <g filter="url(#filter0_dd_5519_21014)">\n    <ellipse cx="23" cy="22.4" rx="20" ry="20.4" fill="#242E2E"/>\n    <ellipse cx="23" cy="22.4001" rx="15" ry="15.3" fill="#E6FFFA"/>\n    </g>\n    <defs>\n    <filter id="filter0_dd_5519_21014" x="0" y="0" width="46" height="58.0625" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n    <feFlood flood-opacity="0" result="BackgroundImageFix"/>\n    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>\n    <feOffset dy="1"/>\n    <feGaussianBlur stdDeviation="1"/>\n    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/>\n    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5519_21014"/>\n    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>\n    <feOffset dy="1"/>\n    <feGaussianBlur stdDeviation="1.5"/>\n    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>\n    <feBlend mode="normal" in2="effect1_dropShadow_5519_21014" result="effect2_dropShadow_5519_21014"/>\n    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_5519_21014" result="shape"/>\n    </filter>\n    </defs>\n    </svg>\n    <p>'.concat(cluster.getChildCount(), "</p>\n    </span>"),
        className: "marker-cluster-custom",
        iconSize: leaflet_src_default().point(40, 51, false)
    });
};

;// CONCATENATED MODULE: ./components/pages/ListingPage/components/Mapbox/index.tsx









var Mapbox = function(props) {
    var onBack = function onBack() {
        setShowMap(false);
    };
    var houseList = props.houseList, showMap = props.showMap, setMapModule = props.setMapModule, setShowMap = props.setShowMap, changePosition = props.changePosition;
    var map = (0,hooks/* useMap */.Sx)();
    (0,react.useEffect)(function() {
        setMapModule(map);
        map.invalidateSize();
        map.attributionControl.setPrefix("Livehomeroom.com \xa9");
    }, [
        showMap
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TileLayer/* TileLayer */.I, {
                maxZoom: 15,
                url: "https://api.mapbox.com/styles/v1/homeroom25/cku2vglim02ei18mnh3d75lo9/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiaG9tZXJvb20yNSIsImEiOiJja3UydmZuc3QydWtxMnhxbmFpc2NrNnphIn0.7IZPSOi2vIo0TfRX74ltSg" || 0,
                attribution: 'Map data \xa9 <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery \xa9 <a href="https://www.mapbox.com/">Mapbox</a>'
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BackButton, {
                onClick: onBack,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FiArrowLeft */.Ao2, {
                        color: "#000"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BackButtonText, {
                        children: "Back to list"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ZoomControl/* ZoomControl */.L, {
                position: "topright"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* default */.Z, {
                iconCreateFunction: createClusterCustomIcon,
                showCoverageOnHover: false,
                singleMarkerMode: false,
                spiderfyOnMaxZoom: false,
                disableClusteringAtZoom: 16,
                children: (0,common/* getValidArray */._b)(houseList).map(function(marker) {
                    var ref, _fakeLng;
                    if (!(0,common/* checkValidCoordinates */.fG)((ref = marker === null || marker === void 0 ? void 0 : marker.fakeLat) !== null && ref !== void 0 ? ref : marker.lat, (_fakeLng = marker.fakeLng) !== null && _fakeLng !== void 0 ? _fakeLng : marker.lng)) {
                        return null;
                    }
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Marker, (0,_object_spread/* default */.Z)({
                        changePosition: changePosition
                    }, marker), "marker-".concat(marker.id));
                })
            })
        ]
    });
};
/* harmony default export */ var components_Mapbox = (Mapbox);


/***/ })

}]);